import { isEmpty, isNull, map, pick } from 'lodash-es'

import { APP_NAME, NO, YES } from '../../../../common/constants'

import { LOCATION_WITH_OWN_MENU } from '../../../../brands/constants'
import { HTML } from '../../../../menus/constants'
import { TASK_AWAITING_REASONS, TASK_REOPEN_REASONS } from '../../../constants'
import { sortLocationsForMenuDefinitionTask } from '../../../helpers'

const getBrandValues = values => {
  const brand = pick(values, 'id', 'name', 'website', 'menu', 'modifiedDate')
  const menu = {
    ...(brand.menu || {}),
    isSimpleMenu:
      brand.menu?.format === HTML ? brand.menu?.isSimpleMenu ?? false : false,
  }

  return {
    ...brand,
    hasMenu: !isEmpty(brand.menu),
    menu,
  }
}

const getLocationInitialValues = values => {
  const location = pick(
    values,
    'id',
    'name',
    'formattedAddress',
    'menuStatus',
    'website',
    'menu',
  )

  return {
    ...location,
    menu: {
      ...location.menu,
      isSimpleMenu:
        location.menuStatus === LOCATION_WITH_OWN_MENU
          ? location.menu?.isSimpleMenu ?? false
          : false,
    },
  }
}

const getTaskValues = values => {
  const task = pick(
    values,
    'id',
    'isAwaiting',
    'status',
    'modifiedDate',
    'reopenedBy',
    'reopenedDate',
    'reopenReason',
    'miscTaskVerifiedBy',
    'miscTaskVerifiedDate',
    'miscTaskVerifiedComment',
    'miscTaskQCVerifiedBy',
    'miscTaskQCVerifiedDate',
    'miscTaskQCVerifiedComment',
    'currentViewType',
    'views',
    'isAssignable',
  )

  return {
    ...task,
    isAssigned: !isNull(values.assignedTo),
    assignedTo: {
      id: values.assignedTo?.id || '',
      name: values.assignedTo?.name || '',
    },
    awaitingReason: values.awaitingReason
      ? TASK_AWAITING_REASONS[values.awaitingReason].name
      : '',
    awaitingReasonComment: values.awaitingReasonComment || '',
    reopenedBy: {
      id: values.reopenedBy?.id || '',
      name: values.reopenedBy?.name || APP_NAME,
    },
    reopenReason: values.reopenReason
      ? TASK_REOPEN_REASONS[values.reopenReason].name
      : '',
    isRerunFlow: values.isRerunFlow ? YES : NO,
    isDone: false,
  }
}

const menuDefinitionTaskState = (values, currentView) => {
  const task = getTaskValues(values)
  const brand = getBrandValues(values.brand || {})
  const { locations } = values.brand

  const locationsSorted = map(
    sortLocationsForMenuDefinitionTask(locations, currentView),
    (location, index) => getLocationInitialValues(location, index),
  )

  return {
    task,
    brand,
    locations: locationsSorted,
  }
}

export default menuDefinitionTaskState
